<template>
  <tsny-modal
    :modal-id="modalId"
    :modal-title="'Delete Course Relationship'"
    :submit-button-text="'DELETE'"
    :reset-modal="resetModal"
    :submit-modal="deleteCourseRelationship"
  >
    <b-row>
      <b-col>
        <p class="tsny_text">
          This action will delete the relationship for the course
          {{ relationship.courseId }} between tutor
          {{ relationship.tutorEmail }} and student
          {{ relationship.studentEmail }} . Please be absolutely certain you
          want to do this -- this action cannot be undone.
        </p>
      </b-col>
    </b-row>
    <b-row>
      <b-col
        ><p class="tsny_status-text" v-if="deleteCourseRelationshipError">
          An error occurred deleting the course relationship
        </p></b-col
      >
    </b-row>
  </tsny-modal>
</template>

<script>
import TsnyModal from "../TsnyModal";
import CourseRelationshipRestService from "../../services/rest/services/CourseRelationshipRestService";

export default {
  name: "DeleteCourseRelationship",
  components: { TsnyModal },
  props: {
    relationship: {
      type: Object,
      default: null
    }
  },
  data: function() {
    return {
      modalId: "deleteCourseRelationshipModal",
      deleteCourseRelationshipError: null
    };
  },
  methods: {
    deleteCourseRelationship: function(bvModalEvt) {
      bvModalEvt.preventDefault();
      let $comp = this;
      $comp.deleteCourseRelationshipError = false;

      return CourseRelationshipRestService.deleteCourseRelationship(
        $comp.relationship._id
      )
        .then(() => {
          $comp.$bvModal.hide($comp.modalId);
        })
        .catch(err => {
          $comp.deleteCourseRelationshipError = true;
          console.log(err);
        });
    },
    resetModal: function() {
      this.deleteCourseRelationshipError = null;
    }
  }
};
</script>

<style scoped></style>
